import type { ColumnsType } from "antd/es/table";
import { StarFilled } from "@ant-design/icons";

export interface CallingFeedbackRow {
  key:       string;
  dateTime:  string;
  feedback:  string;
  rating:    number;
  createdBy: string;
}

/** 1–2 red, 3–4 yellow, 5 green */
export const ratingColor = (rating: number): string => {
  if (rating >= 5) return "#52c41a";
  if (rating >= 3) return "#faad14";
  return "#ff4d4f";
};

const getColumns = (): ColumnsType<CallingFeedbackRow> => [
  {
    title: "Date & Time",
    dataIndex: "dateTime",
    key: "dateTime",
    width: 180,
  },
  {
    title: "Feedback",
    dataIndex: "feedback",
    key: "feedback",
    ellipsis: { showTitle: false },
    render: (text: string) => (
      <span title={text}>{text}</span>
    ),
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    width: 140,
    render: (rating: number) => (
      <span style={{ color: ratingColor(rating), fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>
        <StarFilled /> {rating}
      </span>
    ),
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
    key: "createdBy",
    width: 180,
  },
];

export default getColumns;
